<div class="bg-white rounded-lg py-3 mb-6">
    <div class="flex justify-between items-center mt-3 mb-6 px-6">
        <h1 class="font-semibold">Password Manager</h1>
        <button class="bg-[#D9D9D9] rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clip-path="url(#clip0_1958_7961)">
                <path d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z" fill="#6C757D"/>
            </g>
            <defs>
                <clipPath id="clip0_1958_7961">
                <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
            </svg>
        </button>
    </div>
    <div class="grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">
        <div class="col-span-6 flex flex-col gap-2">
            <h1 class="font-semibold">Roles</h1>
            <select class="w-full border p-2 rounded-md outline-none" formControlName="roles">
                <option selected>Alloted Roles</option>
            </select>
        </div>

        <div class="col-span-6 flex flex-col gap-2">
            <h1 class="font-semibold">Security Pin</h1>
            <input type="text" class="w-full border p-2 rounded-md outline-none" placeholder="Enter Security Pin" formControlName="securityPin">
        </div>

    </div>

</div>

<div class="bg-white rounded-lg py-3 px-12 flex justify-end gap-4">
    <button class="bg-[#0000000a] rounded-lg py-2 px-4">Save</button>
    <button class="bg-[#0058e9] rounded-lg py-2 px-4 text-white">Draft</button>
</div>